import { render, staticRenderFns } from "./AdTask.vue?vue&type=template&id=46bcc606&scoped=true"
import script from "./AdTask.vue?vue&type=script&lang=js"
export * from "./AdTask.vue?vue&type=script&lang=js"
import style0 from "./AdTask.vue?vue&type=style&index=0&id=46bcc606&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bcc606",
  null
  
)

export default component.exports